<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

const show = defineModel<boolean>('show');
const props = defineProps<{
  width?: string;
}>();

const menuRef = ref<HTMLElement>();

// Close menu when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;

  if (show.value && menuRef.value && !menuRef.value.parentElement?.contains(target)) {
    show.value = false;
  }
};

// Close menu when pressing escape
const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    show.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('keydown', handleKeyDown);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  document.removeEventListener('keydown', handleKeyDown);
});
</script>

<template>
  <div class="relative">
    <!-- Activator Slot -->
    <slot name="activator" :props="{ onClick: () => show = !show, 'aria-expanded': show, 'aria-haspopup': true }" />

    <!-- Menu Content -->
    <Transition name="dropdown">
      <div
        v-if="show"
        ref="menuRef"
        class="absolute right-0 mt-2 rounded-lg bg-surface shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
        :style="{ width: width || 'auto' }"
        role="menu"
        aria-orientation="vertical"
      >
        <div class="py-1" role="none">
          <slot />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style> 